export default class DropdownInputElement {
    /** @type {*} */
    #object;
    /** @type {string} */
    #html;
    /** @type {boolean} */
    #enabled;
    /** @type {string} */
    #inputValue;

    /**
     * @param {*} object
     * @param {string} html
     * @param {boolean?} enabled
     * @param {string?} inputValue
     */
    constructor(object, html, enabled, inputValue) {
        this.#object = object;
        this.#html = html;
        this.#enabled = enabled;
        this.#inputValue = inputValue
    }

    /** @returns {string} */
    get html(){
        return this.#html
    }

    /** @returns {*} */
    get object(){
        return this.#object
    }

    /** @returns {boolean} */
    get enabled(){
        return this.#enabled
    }

    /** @returns {string} */
    get inputValue(){
        return this.#inputValue
    }
}